import { useEffect } from 'react';

/** Put a class on <body> while the component is mounted and `active` (scroll lock, mode-specific styles). */
export function useBodyClass(name: string, active = true) {
  useEffect(() => {
    if (!active) return;
    document.body.classList.add(name);
    return () => document.body.classList.remove(name);
  }, [name, active]);
}
